import { render, staticRenderFns } from "./LegacyView.vue?vue&type=template&id=f33ddbbe&scoped=true&"
import script from "./LegacyView.vue?vue&type=script&lang=js&"
export * from "./LegacyView.vue?vue&type=script&lang=js&"
import style0 from "./LegacyView.vue?vue&type=style&index=0&id=f33ddbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33ddbbe",
  null
  
)

export default component.exports